import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import ProjectIcon from './ProjectIcon';
import '../pages/Blog.css';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

// Shared post card used on the homepage teaser, the blog list and the
// "Read next" sections of a post page, so all three stay visually in sync.
const BlogCard = ({ post }) => (
  <Link to={`/blog/${post.slug}`} className={`blog-card tone-${post.tone}`}>
    <img
      className="blog-card-img"
      src={post.cover}
      alt={post.coverAlt}
      width="1200"
      height="630"
      loading="lazy"
    />
    <div className="blog-card-body">
      <div className="blog-card-top">
        <span className="blog-card-icon"><ProjectIcon name={post.icon} size={18} /></span>
        <span className="blog-card-cat">{post.category}</span>
      </div>
      <h2>{post.title}</h2>
      <p>{post.excerpt}</p>
      <div className="blog-card-meta">
        <span><Calendar size={13} /> {formatDate(post.date)}</span>
        <span><Clock size={13} /> {post.readTime}</span>
      </div>
    </div>
  </Link>
);

export default BlogCard;
